import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Forms',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
